module.exports = __webpack_public_path__ + "img/new-request.675f2b2a.svg";